import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormLifeYearsInput.module.css";
import {TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";

const FormLifeYearsInput = ({label, initFromValue, initTillValue, controlRef}) => {

    const inputFromRef = useRef(null);
    const inputTillRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getFromYear: () => getCurrentValue(inputFromRef),
                getTillYear: () => getCurrentValue(inputTillRef),
                validateInputs: validateInputs,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getCurrentValue(inputRef) {
        const strValue = inputRef.current.value;

        if (strValue === "")
            return null;

        return parseInt(strValue);
    }

    function validateInputs() {
        const fromVal = getInputValueAsIntegerOrNull(inputFromRef);
        const tillVal = getInputValueAsIntegerOrNull(inputTillRef);

        if (fromVal === null && tillVal !== null)
            return false;

        if (fromVal !== null && isNaN(fromVal))
            return false;

        if (tillVal !== null && isNaN(tillVal))
            return false;

        if (fromVal !== null && tillVal !== null && fromVal > tillVal)
            return false;

        return true;
    }

    function getInputValueAsIntegerOrNull(inputRef) {
        const value = inputRef.current.value;

        if (!value || value.trim().length === 0)
            return null;

        const intVal = parseInt(value, 10);
        if (isNaN(intVal))
            return NaN;

        return intVal;
    }


    function renderTextField(inputRef, initValue, error, errorMessage) {
        return <TextField
            type="text"
            variant="outlined"
            hiddenLabel
            inputRef={inputRef}
            defaultValue={initValue}
            placeholder="ГГГГ"
            error={error}
            helperText={errorMessage}
            sx={{width: `min(80px, 40%)`}}
            slotProps={{
                htmlInput: {
                    sx: {backgroundColor: "white", borderRadius: "4px"}
                },
                formHelperText: {
                    sx: {width: "max-content", maxWidth: "350px"}
                }
            }}
            onChange={() => {
                if (error)
                    setErrorMessage("")
            }}
        />
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={"Если годы жизни неизвестны, оставьте поля пустыми.\nЕсли известен только год рождения (человек жив по сей день), оставьте второе поле пустым.\nДля указания года 'до н.э.' поставьте знак минус перед числом."}
            />
            <div className={cl.row}>
                {renderTextField(inputFromRef, initFromValue, errorMessage !== "", errorMessage)}
                <span style={{marginTop: "18px"}}>—</span>
                {renderTextField(inputTillRef, initTillValue, errorMessage !== "", "")}
            </div>
        </div>
    );
};

export default FormLifeYearsInput;